import { useEffect } from "react";
import { useBlocker, type Blocker } from "react-router";

/** "Unsaved changes" on the way out (the form builder, round one; red team finding 9, question 12): while `dirty`, a move inside the app is
 *  held (the screen shows its dialog: Stay or Leave without saving, answered through the blocker) and the browser asks before a reload or a
 *  closed tab. A move to the same page (a search parameter) is never held. */
export function useLeaveGuard(dirty: boolean): Blocker {
  const blocker = useBlocker(({ currentLocation, nextLocation }) => dirty && currentLocation.pathname !== nextLocation.pathname);
  useEffect(() => {
    if (!dirty) return;
    const ask = (e: BeforeUnloadEvent) => { e.preventDefault(); e.returnValue = ""; };
    window.addEventListener("beforeunload", ask);
    return () => window.removeEventListener("beforeunload", ask);
  }, [dirty]);
  return blocker;
}
